import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-dialog-warn',
  templateUrl: './dialog-warn.component.html',
  styleUrl: './dialog-warn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    //Material
    MatDialogModule,
    MatButtonModule,
  ],
})
export class DialogWarnComponent {
  private readonly _dialogRef = inject(MatDialogRef<DialogWarnComponent>)
  data = inject(MAT_DIALOG_DATA) as {
    title: string
    message: string
    cancelText?: string
    confirmText?: string
  }
  constructor() {
    this.data.cancelText = this.data.cancelText ?? 'Cancel'
    this.data.confirmText = this.data.confirmText ?? 'Delete'
  }

  onConfirm() {
    this._dialogRef.close(true)
  }
}
